import { createApp } from 'vue';
import PictToWebpConverter from '../Components/PictToWebpConverter.vue';

createApp(PictToWebpConverter).mount('#pict-to-webp-converter');
